"use client";

import { popupbannerDetails } from "@/data/popupbanner";
import { useState, useEffect } from "react";

export default function PopupBanner() {
  const [isVisible, setIsVisible] = useState(true);

  // Automatically hide after 20 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 10000);

    return () => clearTimeout(timer); // cleanup if unmounted
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 max-w-md z-50">
      <div className="bg-white/40 backdrop-blur-md border border-white/20 rounded-lg shadow-lg p-4 relative">
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-2 right-2 text-primary-accent hover:text-primary"
          aria-label={popupbannerDetails.closeButtonAriaLabel}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <svg className="h-8 w-8 text-primary-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-medium text-green-800 mb-1">
              {popupbannerDetails.title}
            </h3>
            <p className="text-green-900">{popupbannerDetails.content[0]}</p>
            <p className="text-green-900 mt-2">{popupbannerDetails.content[1]}</p>
            <div className="mt-3">
              <a
                href="#waitlist"
                className="bg-primary-accent hover:bg-primary text-white font-medium py-2 px-4 rounded-md transition-colors block text-center"
              >
                {popupbannerDetails.buttonText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
